<li style="width: 100%">
  <div class="columns">
    <div class="column is-narrow">
      <svg class="folder-opened" [attr.folder-id]="folder.id" xmlns="http://www.w3.org/2000/svg" width="13.496" height="10.122"
           viewBox="0 0 13.496 10.122">
        <path id="Pfad_614" data-name="Pfad 614"
              d="M12.231,65.687H7.17L5.483,64H1.265A1.265,1.265,0,0,0,0,65.265v7.592a1.265,1.265,0,0,0,1.265,1.265H12.231A1.265,1.265,0,0,0,13.5,72.857v-5.9A1.265,1.265,0,0,0,12.231,65.687Z"
              transform="translate(0 -64)" fill="#707070"/>
      </svg>
      <svg class="folder-closed" [attr.folder-id]="folder.id"  style="display: none" xmlns="http://www.w3.org/2000/svg"
           width="15.184" height="10.122" viewBox="0 0 15.184 10.122">
        <path id="Pfad_616" data-name="Pfad 616"
              d="M15.1,70.013l-1.909,3.273a1.687,1.687,0,0,1-1.457.837H1.187a.633.633,0,0,1-.546-.951L2.55,69.9a1.687,1.687,0,0,1,1.457-.837H14.55A.633.633,0,0,1,15.1,70.013ZM4.007,68.218h8.646V66.952a1.265,1.265,0,0,0-1.265-1.265H7.17L5.483,64H1.265A1.265,1.265,0,0,0,0,65.265v7.329l1.821-3.122A2.539,2.539,0,0,1,4.007,68.218Z"
              transform="translate(0 -64)" fill="#707070"/>
      </svg>
    </div>
    <div class="column is-narrow">
      <p (click)="toggleFolder(folder.id)" class="is-clickable">{{folder.folderName}}</p>
    </div>
  </div>
</li>
<li>
  <ul [attr.folder-id]="folder.id" class="menu-list folder" style="display:none">
    <li *ngFor="let subFolder of folder.subFolders">
      <app-file-explorer-position [folder]="subFolder" [files]="subFolder.files"></app-file-explorer-position>
    </li>
    <li *ngFor="let file of folder.files">
      <div class="columns mt-1 mb-1">
        <div class="column is-narrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="11.192" height="14.923" viewBox="0 0 11.192 14.923">
            <path id="Pfad_615" data-name="Pfad 615"
                  d="M5.3,7.464A2.812,2.812,0,0,1,5.243,6.1C5.488,6.1,5.465,7.173,5.3,7.464ZM5.252,8.84a13.449,13.449,0,0,1-.828,1.827,10.732,10.732,0,0,1,1.833-.638A3.775,3.775,0,0,1,5.252,8.84ZM2.509,12.477c0,.023.385-.157,1.017-1.172A4.028,4.028,0,0,0,2.509,12.477ZM7.228,4.663h3.964v9.56a.7.7,0,0,1-.7.7H.7a.7.7,0,0,1-.7-.7V.7A.7.7,0,0,1,.7,0H6.529V3.964A.7.7,0,0,0,7.228,4.663ZM6.995,9.67A2.925,2.925,0,0,1,5.75,8.1a4.189,4.189,0,0,0,.181-1.871.73.73,0,0,0-1.393-.2,4.846,4.846,0,0,0,.236,2.244,27.368,27.368,0,0,1-1.189,2.5s0,0-.006,0c-.79.405-2.145,1.3-1.588,1.982a.906.906,0,0,0,.627.291c.522,0,1.04-.525,1.781-1.8a16.613,16.613,0,0,1,2.3-.676,4.417,4.417,0,0,0,1.865.568A.754.754,0,0,0,9.14,9.88C8.735,9.484,7.557,9.6,6.995,9.67Zm3.993-6.61L8.132.2a.7.7,0,0,0-.5-.2H7.461V3.731h3.731V3.553A.7.7,0,0,0,10.988,3.06ZM8.828,10.5c.119-.079-.073-.347-1.247-.262C8.662,10.7,8.828,10.5,8.828,10.5Z"
                  fill="#b30c00"/>
          </svg>
        </div>
        <div class="column has-text-left is-narrow">
          <p (click)="downloadDocumentFile(file.id)" class="is-clickable">{{file.fileName}}</p>
        </div>
      </div>
    </li>
  </ul>
</li>
